
import flatpickr from 'flatpickr';
import { Latvian } from 'flatpickr/dist/l10n/lv.js';


$(document).ready(function(){

  flatpickr(".js-datepicker", {
    locale: Latvian,
    dateFormat: "d.m.Y", // Latvian date format (DD.MM.YYYY)
    minDate: "today", // Restrict past dates
    firstDay: 1, // Monday as first day
    disableMobile: true, // Ensure consistent desktop behavior
    onReady: function() {
      // Optional: Add animation if desired
      this.calendarContainer.style.opacity = 0;
      this.calendarContainer.style.transition = 'opacity 0.2s';
      setTimeout(() => {
        this.calendarContainer.style.opacity = 1;
      }, 0);
    }
  });

})